import { fileChecksum } from "./fileChecksum";
import sh from "./sh";

const createPresignedUrl = async (file, folder, contentType) => {
  const checksum = await fileChecksum(file);
  const res = await fetch("/presigned_url", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      file: {
        filename: file.name,
        byte_size: file.size,
        checksum,
        content_type: contentType,
        metadata: { folder },
      },
    }),
  });
  if (res.status !== 200) throw new Error("Presigned URL request failed");
  return res.json();
};

export const directUpload = async (file, folder, contentType) => {
  const presignedFileParams = await createPresignedUrl(file, folder, contentType);
  const uploadRes = await fetch(presignedFileParams.direct_upload.url, {
    method: "PUT",
    headers: presignedFileParams.direct_upload.headers,
    body: file,
  });
  // Without this check a failed upload would still hand back a blob id pointing at nothing.
  if (!uploadRes.ok) throw new Error(`Direct upload failed (${uploadRes.status})`);
  return presignedFileParams;
};

export const attachResumeToCandidate = async ({
  id,
  authenticity_token,
  blob_signed_id,
}) => {
  const params = {
    authenticity_token,
    candidate: {
      id,
      resume: blob_signed_id,
    },
  };
  let res = await sh.put("/upload_resume", params);
  return res?.data || res;
};

export const attachPortfolioToCandidate = async ({
  id,
  authenticity_token,
  blob_signed_id,
}) => {
  const params = {
    authenticity_token,
    candidate: {
      id,
      portfolio: blob_signed_id,
    },
  };
  let res = await sh.put("/upload_portfolio", params);
  return res?.data || res;
};

export const uploadResume = async (resume) => {
  return directUpload(resume, "resumes", "application/pdf");
};

export const uploadDocument = async (file) => {
  return directUpload(file, "documents", file.type || "application/octet-stream");
};

export const uploadPortfolio = async (portfolio) => {
  return directUpload(portfolio, "portfolios", portfolio.type || "application/pdf");
};
